const FlowTypes = Object.freeze({
  FREE: 'free',
  SEQUENTIAL: 'sequential',
});

export { FlowTypes };